import { FC, PropsWithChildren, ReactNode } from "react";
import { Typography } from '@mui/material';
import { LoadingSpinner } from '@hubdevs/viu-ui-shared';
import './Page.css';


export const AppPage: FC<PropsWithChildren<{
    title?: string;
    buttonRowContent?: ReactNode | undefined;
    isLoading?: boolean;
    [key: string]: any;
}>> = ({children, title, className,  isLoading, buttonRowContent, ...props}) => (
    <div
        { ...props }
        className={ `app-page ${ className || ''}`}
    >
        {
            title
            ? (
                <div className="app-page-header" >
                    <div className="app-page-header-content" >
                        <Typography variant="h5" className="app-page-header-text" >{ title }</Typography>
                    </div>
                </div>
            )
            : null
        }
        <div className={`app-page-body${isLoading ? ' is-loading' : '' }`} >
            <div className="app-page-content" >
                {children}
            </div>
        </div>
        {
            buttonRowContent
            ? (
                <div className="app-page-footer" >
                    <div className="app-page-footer-content" >
                        { buttonRowContent }
                    </div>
                </div>
            )
            : null
        }
        {isLoading && (
            <div
                className="app-page-loading-overlay"
                aria-busy="true"
                aria-live="polite"
                role="status"
            >
                <div className="app-page-loading-box">
                    <LoadingSpinner />
                    
                </div>

            </div>
        )}
    </div>
);
